import '../styling/global.css';
import img from '../assets/website_logo.png';
import img1 from '../assets/1.png';
import img2 from '../assets/2.png';
import img3 from '../assets/5.png';
import img4 from '../assets/4.png';
import img5 from '../assets/3.png';
import img6 from '../assets/6.png';
import home1 from '../assets/home1.png';
import home2 from '../assets/home2.png';
import home3 from '../assets/home3.png';
import home4 from '../assets/home4.png';
import home5 from '../assets/home5.png';
import home6 from '../assets/home6.png';
import BackgroundEffect from '../components/BackgroundEffect';
import React, { useEffect, useState } from 'react';

const textBlocks = [
  {
    title: '"Ultimate experience with story,\n emotion and purpose"',
    description:
      'JSK Technologies is a full-service provider and offers both standardized and individual\nsolutions for its customers\' data-oriented projects implementations.',
  },
  {
    title: '"We work with the motto of providing\n the depth of the research in time"',
    description:
      'We hire talented people who have skills in languages, Research and AI technology\n to provide in-depth analysis for our services. Our jobs empower you with the experience of working\n on projects for cutting-edge IT & Non- IT companies.',
  },
  {
    title: '"Strategy, creativity\n and innovative!"',
    description:
      'JSK Technologies services are powered by outsourcing, the most exciting and present\n rapidly growing business concept for today’s business world.',
  },
];

const images = [img1, img2, img3, img4, img5, img6];
const repeatedImages = [...images, ...images, ...images, ...images];

const images1 = [home1, home2, home3, home4, home5, home6];
const repeatedImages1 = [...images1, ...images1, ...images1, ...images1];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % textBlocks.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <main className="home">
      <BackgroundEffect />

      <section className="hero-section">
        <img src={img} alt="website_logo" className="hero-image" />

        <div className="text-block-wrapper">
          {textBlocks.map((block, index) => (
            <div
              key={index}
              className={`text-block fade ${index === currentIndex ? 'visible' : ''}`}
            >
              <h1>{block.title}</h1>
              <p>{block.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="scrolling-images">
        <div className="image-track">
          {[...repeatedImages, ...repeatedImages].map((img, index) => (
            <img src={img} alt={`scroll-img-${index}`} key={index} className="scroll-image" />
          ))}
        </div>
      </section>

      <section className="info-section">
        <p>
          We hire talented people who have skills in languages, Research and AI technology to provide in-depth analysis for our services. Our jobs empower
          you with the experience of working on projects for cutting-edge IT & Non- IT companies.
        </p>
        <h1>Hire a Resource or a Team On Hourly basis or project basis:</h1>
        <ul>
          <li>Cost-Effective: Save up to 60% operating Costs.</li>
          <li>Save Big! Minimize work expenses.</li>
          <li>Highly Skilled workforce available 24/7/365 days.</li>
        </ul>
        <h2>Ultimate experience with story, emotion and purpose</h2>
        <ul>
          <li>JSK Technologies Building future to inspire is a leading company in Vijayawada founded in November, 2008.</li>
          <li>Our team at JSK Technologies are highly qualified and dedicated to the work.</li>
          <li>JSK Technologies is known to be experts in providing solutions and services to deliver the right content to the right users at the right time.</li>
        </ul>

        
        <h2 className='content-heading'>Empowering Innovation. Delivering Excellence.</h2>
        <p>
          Founded in November 2008 in Vijayawada, India, JSK Technologies is a future-ready technology and talent solutions company. We bridge the gap
          between evolving business needs and cutting-edge digital solutions. With over 15 years of experience, we provide reliable, cost-effective,
          and scalable services across industries.
        </p>
        <p>
          <strong style={{color: "#000000"}}>Our mission is simple: </strong>Empower organizations through exceptional talent, technology, and innovation.
        </p>

        <h1 className='centered-text'>Our Services</h1>
        <h2>Tailored Expertise Across Domains</h2>
        <p>We provide high-performance resources and solutions in:</p>
        <ul>
          <li><strong>Language & Content Services:</strong> Multilingual experts for translation, content creation, localization, and communication support.</li>
          <li><strong>AI, ML & Research Solutions:</strong> In-depth academic, market, and technical research powered by AI-based methodologies.</li>
          <li><strong>IT Development & Consulting:</strong> Web/mobile development, UI/UX, cloud integration, and digital transformation.</li>
          <li><strong>Data Analytics & Insights:</strong> Turn raw data into strategic insights with our analytics and reporting specialists.</li>
        </ul>
        <p>We blend human intelligence with AI to create smarter, faster, and more personalized results.</p>

        <h1 className='centered-text'>How You Can Work With Us</h1>
        <h2>Flexible Engagement Models to Fit Every Business</h2>
        <ul>
          <li><strong>Hourly Resource Hiring:</strong> Ideal for short-term tasks, support, or testing concepts.</li>
          <li><strong>Project-Based Engagements:</strong> Get a dedicated team for full-cycle project development or research.</li>
          <li><strong>Long-Term Resource Allocation:</strong> Seamlessly integrate skilled professionals into your existing workflows.</li>
        </ul>
        <p>We offer rapid onboarding, minimal admin overhead, and guaranteed productivity.</p>

        <h1 className='centered-text'>Why JSK Technologies?</h1>
        <h2>Your Success Is Our Business</h2>
        <ul>
          <li><strong>Cost-Efficient:</strong> Reduce operational costs by up to 60%</li>
          <li><strong>Always Available:</strong> 24/7/365 workforce for global coverage</li>
          <li><strong>Highly Skilled Talent:</strong> Handpicked, domain-expert professionals</li>
          <li><strong>Custom-Built Solutions:</strong> We adapt to your goals and industry</li>
          <li><strong>Quick Turnaround Time:</strong> Faster delivery without compromising quality</li>
          <li><strong>Trusted Delivery Partner:</strong> Transparent processes & consistent results</li>
        </ul>

        <h2>Our Unique Edge</h2>
        <p><strong>Beyond Services – We Create Impact</strong></p>
        <ul>
          <li><strong>With Story:</strong> Every project has a narrative and a goal.</li>
          <li><strong>With Emotion:</strong> We care deeply about user experience and results.</li>
          <li><strong>With Purpose:</strong> Every solution is aligned to real business outcomes.</li>
        </ul>
        <p>We ensure your content, technology, and people deliver the right message to the right audience at the right time.</p>

        <h2>Trusted Across Industries</h2>
        <p>We've successfully supported clients in:</p>
        <ul>
          <li>Logistics & Supply Chain</li>
          <li>Healthcare & Life Sciences</li>
          <li>Education & E-learning</li>
          <li>Finance & Insurance</li>
          <li>E-commerce & Retail</li>
          <li>IT Services & SaaS</li>
        </ul>
        <p>From startups to enterprises, our flexible model fits businesses of all sizes.</p>
      </section>
       <section className="scrolling-images">
        <div className="image-track">
          {[...repeatedImages1, ...repeatedImages1].map((img, index) => (
            <img src={img} alt={`scroll-img-${index}`} key={index} className="scroll-image" style={{marginBottom: "3.2rem"}} />
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
